// Остатки денег на счетах: расчёт и вспомогательные фабрики.
import { getPaymentValue } from "./reportWidgets";

export const REGISTER_PAGE_ID = "__register__";

export const toNumber = (value) => {
  const n = Number(String(value ?? "").replace(/\s/g, "").replace(",", ".").trim());
  return Number.isNaN(n) ? 0 : n;
};

// accountsTotal = сумма счетов; каждая строка-вычет = у платежей, подходящих под условие,
// суммируется выбранный числовой столбец (deduction.field, по умолчанию amount);
// remainder = Итого − сумма вычетов.
export function computeBalances(balances = {}, payments = [], templateColumns = []) {
  const accounts = balances.accounts || [];
  const accountsTotal = accounts.reduce((sum, account) => sum + toNumber(account.amount), 0);

  const deductions = (balances.deductions || []).map((deduction) => {
    const field = deduction.field || "amount";
    const op = deduction.op === "plus" ? "plus" : "minus";
    const amount = payments
      .filter((p) =>
        deduction.columnId === "status"
          ? p.status === deduction.value
          : p.extra_fields?.[deduction.columnId] === deduction.value
      )
      .reduce((sum, p) => sum + toNumber(getPaymentValue(p, field, templateColumns)), 0);

    return { id: deduction.id, label: deduction.label, amount, op };
  });

  const remainder =
    accountsTotal +
    deductions.reduce((sum, d) => sum + (d.op === "plus" ? d.amount : -d.amount), 0);

  return { accountsTotal, deductions, remainder };
}

let seq = 0;
const uid = (prefix) => {
  seq += 1;
  return `${prefix}_${Date.now()}_${seq}`;
};

export const newAccount = () => ({ id: uid("acc"), name: "", amount: "" });
export const newDeduction = () => ({ id: uid("ded"), label: "", columnId: "", value: "", field: "amount", op: "minus" });

// Числовые столбцы, которые можно суммировать в вычете.
export function getNumericFields(templateColumns = []) {
  const fields = templateColumns
    .filter((column) => column.key === "amount" || column.format === "number")
    .map((column) => ({ key: column.key || column.id, label: column.label }));

  if (!fields.some((f) => f.key === "amount")) {
    fields.unshift({ key: "amount", label: "Сумма" });
  }

  return fields;
}

// Источники для вычетов: значения столбцов выбора (из шаблона «Столбцы выбора»).
export function getDeductionSources(actionColumns = []) {
  return actionColumns.flatMap((column) =>
    column.options.map((option) => ({
      key: `${column.id}::${option.value}`,
      columnId: column.id,
      value: option.value,
      label: `${column.label}: ${option.label}`
    }))
  );
}
